import React, { Suspense } from 'react';
import { HomePageShimmer } from './HomePageShimmer';
import { Home } from './homePage';
export const HomePageEntry: React.FC = () => {
  return (
    <Suspense fallback={<HomePageShimmer />}>
      <Home />
    </Suspense>
  );
}